// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__CluWb","popover__text":"Popover_popover__text__swQ3Z","popover__content":"Popover_popover__content__1jiLB"};